export default {
  data () {
    return {
      previousPage: '/dashboard'
    }
  },
  methods: {
    goBack () {
      this.$router.replace(this.previousPage)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.previousPage = from.path === '/loading' ? vm.previousPage : from.path
      next()
    })
  }
}
